import { Injectable } from '@angular/core';
import {
  FieldAgentClient, CustomerSearchParameters,
  CustomerSearchParametersCustomerStatus, SortParametersDirection, CustomerSearchParametersDeliverytype
} from 'ep-bt-field-agent-proxy';
import { BistrackConfig, PageNames, CustomerStatusType, CustomerStatusIcon,
  CustomerStatusColor, LocalStorageSaveTypes } from 'ep-bt-controls';
import { EpbtFieldAgentService } from '../services/epbt-field-agent.service';
import {
  CustomerCreditControlStatusType
} from 'ep-bt-field-agent-proxy';
@Injectable({
  providedIn: 'root'
})
export class EpbtFaCustomerService {

  public selectedCustomer: any;
  public fromPage = PageNames.CustomerSearch;
  public searchString: string;
  isOpportunityDashboard = false;
  isNotepadDashboard = false;
  isContactDashboard = false;
  isCustomersSearchMessage = false;
  isDefaultAddress = true;

  constructor(private client: FieldAgentClient, private config: BistrackConfig, private faService: EpbtFieldAgentService) {
  }

  getCustomerbyCustomerId(customerId: number,
    subscribe: (customer: any) => void) {

    this.client.getCustomer(customerId).subscribe(res => {
      subscribe(res);
      // console.log('result :' + res);
    });
  }

  getCustomers(searchString: string, isCompetitor: number, subscribe: (customers: any) => void) {
    const searchCustomerParams = new CustomerSearchParameters();
    searchCustomerParams.competitor = isCompetitor;
    searchCustomerParams.customerStatus = isCompetitor == 0 ? CustomerSearchParametersCustomerStatus.CustomerOrProspect : CustomerSearchParametersCustomerStatus.All;
    searchCustomerParams.customersLimitSearchToHomeBranch = true;
    searchCustomerParams.paging = this.faService.paging(0, 50);
    searchCustomerParams.sorting = this.faService.sorting('name', SortParametersDirection.Ascending);
    searchCustomerParams.searchText = searchString;
    searchCustomerParams.deliverytype = CustomerSearchParametersDeliverytype.All;
    searchCustomerParams.bisTrackUserID = this.config.getLoggedinUser();
    this.client.findCustomers(searchCustomerParams).subscribe(res => {
      subscribe(res.lines);
    });
  }

  // This method will return single customer/competitor if the only one record is matching with the search string
  getCustomer(searchString: string, isCompetitor: number, subscribe: (customer: any) => void) {
    const searchCustomerParams = new CustomerSearchParameters();
    searchCustomerParams.competitor = isCompetitor;
    searchCustomerParams.customerStatus = isCompetitor == 0 ? CustomerSearchParametersCustomerStatus.CustomerOrProspect : CustomerSearchParametersCustomerStatus.All;
    searchCustomerParams.customersLimitSearchToHomeBranch = true;
    searchCustomerParams.paging = this.faService.paging(0, 50);
    searchCustomerParams.sorting = this.faService.sorting('name', SortParametersDirection.Ascending);
    searchCustomerParams.searchText = searchString;
    searchCustomerParams.deliverytype = CustomerSearchParametersDeliverytype.All;
    searchCustomerParams.bisTrackUserID = this.config.getLoggedinUser();
    this.client.findCustomers(searchCustomerParams).subscribe(res => {
      if (res && res.lines.length == 1) {

        this.getcustomerStatus(res.lines);
        console.log(res.lines);
        subscribe(res.lines[0]);
      } else {
        subscribe(false);
      }
    });
  }

  getcustomerStatus(customersList) {
    customersList.forEach(function (e) {
      if (typeof e === 'object') {
        e['statusText'] = '';
        e['statusIcon'] = '';
        e['statusColor'] = '';
      }
      if (e.onHold || e.creditControlStatusType == CustomerCreditControlStatusType.Stop) {
        e.statusText = CustomerStatusType.OnHold;
        e.statusIcon = CustomerStatusIcon.OnHold;
        e.statusColor = CustomerStatusColor.OnHold;
      } else if (e.creditControlStatusType == CustomerCreditControlStatusType.ProceedWithWarning || e.creditControlStatusType == CustomerCreditControlStatusType.ProceedOnHold) {
        e.statusText = e.creditControlStatusType == CustomerCreditControlStatusType.ProceedWithWarning ? CustomerStatusType.ProceedWithWarning : CustomerStatusType.ProceedOnHold;
        e.statusIcon = CustomerStatusIcon.ProceedWithWarning;
        e.statusColor = CustomerStatusColor.ProceedWithWarning;
      } else if (!e.cashAccount) {
        if (e.availableCredit < 0) {
          e.statusText = CustomerStatusType.NoAvailableCredit;
          e.statusIcon = CustomerStatusIcon.NoAvailableCredit;
          e.statusColor = CustomerStatusColor.NoAvailableCredit;
        } else if (e.hasOverDueBalance && !e.cashAccount) {
          e.statusText = CustomerStatusType.BalanceOverDue;
          e.statusIcon = CustomerStatusIcon.BalanceOverDue;
          e.statusColor = CustomerStatusColor.BalanceOverDue;
        }
      }
    });
  }

}
